import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLinkActions } from './useLinkActions';
import type {
  AddCandidateDialogParams,
  NewCandidateFormData,
  UseAddCandidateDialogReturn,
} from '../components/candidates/AddCandidateDialog.types';

export type { UseAddCandidateDialogReturn };

export function useAddCandidateDialog({
  positionId,
  onOpenChange,
}: AddCandidateDialogParams): UseAddCandidateDialogReturn {
  const [activeTab, setActiveTab] = useState<'existing' | 'new'>('existing');
  const [selectedCandidateId, setSelectedCandidateId] = useState<string | null>(null);
  const [country, setCountry] = useState('');
  const form = useForm<NewCandidateFormData>({
    defaultValues: { name: '', email: '', country: '' },
  });
  const handleClose = (): void => {
    setSelectedCandidateId(null);
    setCountry('');
    form.reset();
    setActiveTab('existing');
    onOpenChange(false);
  };
  const {
    linkExisting,
    createAndLink,
    isLoading: isAdding,
  } = useLinkActions(positionId, handleClose);
  return {
    activeTab,
    setActiveTab,
    selectedCandidateId,
    setSelectedCandidateId,
    country,
    setCountry,
    isAdding,
    form,
    handleClose,
    handleLinkExisting: () => {
      if (selectedCandidateId) linkExisting(selectedCandidateId);
    },
    handleCreateAndLink: form.handleSubmit((d) =>
      createAndLink(d.name, d.email, country || undefined)
    ),
  };
}
